export default __webpack_public_path__ + "static/media/female_blue.abf0d5de.png";